var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCategory1 = function SvgCategory1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "category1_svg__w-full category1_svg__h-full",
    viewBox: "0 0 44 44"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.8,
    d: "M22 44C9.87 44 0 34.13 0 22S9.87 0 22 0s22 9.87 22 22-9.87 22-22 22m0-42.15C10.89 1.85 1.85 10.89 1.85 22S10.89 42.15 22 42.15 42.15 33.11 42.15 22 33.11 1.85 22 1.85M20.49 35.64a.93.93 0 0 1-.93-.924V24.96a.556.556 0 0 0-.556-.555h-4.2a.925.925 0 0 1-.82-1.352l7.405-14.197a.924.924 0 0 1 1.744.427v9.133c0 .305.25.554.555.554h5.508a.925.925 0 0 1 .798 1.393l-8.707 14.822a.92.92 0 0 1-.797.456m-4.161-13.085h2.675a2.407 2.407 0 0 1 2.404 2.404v6.367l6.173-10.507h-3.893a2.407 2.407 0 0 1-2.404-2.404v-5.36z"
  })));
};
export default SvgCategory1;